// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__266MH","colMin":"styles_colMin__3b9mK"};